import { Component, OnInit, Input, Output, EventEmitter, ViewContainerRef } from '@angular/core';
import { NzMessageService } from 'ng-zorro-antd/message';
import { environment } from 'environments/environment';
import { TranslateService } from '@ngx-translate/core';
// import { IntimationService } from '../../../BaseFramework/core/http/intimation.service';
import { Router, ActivatedRoute } from '@angular/router';
import { DatePipe } from '@angular/common';
import { Observable, forkJoin } from 'rxjs';
import { IntimationService } from 'app';
import { AdaptersService } from 'app';
import { AppMetadataHandler } from 'app';

import { HttpRequest, HttpClient, HttpEventType, HttpEvent, HttpResponse, HttpHeaders } from '@angular/common/http';
import {
    ValidationUtilService,
    ApiRequestService,
    LookupDataService,
    CommonUtilty,
    I18nService,
    MultiLingualService,
    InteractService,
    UserInfoService,
    ComponentOutputDO,
    GuidGenerator
} from 'app'
import { AbstractControl, FormBuilder, FormControl, FormGroup, FormArray, Validators } from '@angular/forms';
// import { AppConfig } from './../../../BaseFramework/configs/app.config';
import { AppConfig } from 'app';
import * as moment from 'moment/moment';
import { NzSkeletonModule } from 'ng-zorro-antd/skeleton';

@Component({
    selector: 'app-reports',
    templateUrl: './reports.component.html',
    styleUrls: ['./reports.component.scss']
})
export class ReportsComponent implements OnInit {
    _currentComponentName = 'ReportsComponent'
    reportList = [];
    // [{"lookupKey": "Consolidated Claims Report", "lookupValue": "IntRpt" },
    //              {"lookupKey": "Policy Report", "lookupValue": "PolicyRpt" }];
    fromPeriod = null;
    toPeriod = null;
    reportName = null;
    subReportName = null;
    reportNamesList = [];
    subReportNamesList = [];
    dateFrequency = ["Daily","Monthly","Quarterly","Yearly","Financial Year","Since Inception"];
    selectedDateFrequency = null;
    culminatedReportName = null;
    hideSubReportField = true;

    maxDate = new Date();
    minDate = "2000-01-01";
    
    fiscalQuarter = [
        {"lookupKey":"AMJ" , "lookupValue":"April May June" , "qtrStartDate":"01-04" , "qtrEndDate":"30-06"},
        {"lookupKey":"JAS" , "lookupValue":"July August September" , "qtrStartDate":"01-07" , "qtrEndDate":"30-09"},
        {"lookupKey":"OND" , "lookupValue":"October November December" , "qtrStartDate":"01-10" , "qtrEndDate":"31-12"},
        {"lookupKey":"JFM" , "lookupValue":"January February March" , "qtrStartDate":"01-01" , "qtrEndDate":"31-03"}
    ];
    
    masterReportNAME = [
        {"lookupKey":"DAILY_MIS_NBU" , "lookupValue":"Daily MIS NBU"},
        {"lookupKey":"DAILY_ISSUANCE_TAT_NBU" , "lookupValue":"Daily MIS TAT"},
        {"lookupKey":"DAILY_MIS_PRODUCTIVITY_NBU" , "lookupValue":"Daily MIS Productivity Report"}
    ];
    usersRoles = [];
    lookupsToBind = ["nbuReportNames", "subReportNames"];
    inputLookups = [];
    reportData = [{ "CLMINTIMATIONNUM": "", "EVENTTYPECD": "", "POLICYNUM": "", "EVENTDT": "" }];
    reportMetaData = null;
    proposalNum = null;
    user = null;
    inputValue = null;
    showReportTable = false
    fileName = null;

    reportInputfields = [];
    reportOutputFields = [];
    tabelHeaders = [];
    inputFieldsMap = [];
    //ui varaibles

    mapperTableIndex: number = 1;  
    mapperTablePageSize: number = 10;

    names;
    field;
    column;
    report;
    frequency;

    // listOfOption: Array<{ label: string; value: string }> = [];
    listOfOption = [
        {
            label: 'Type',
            value: 'Type',
            hide: false
        },
        {
            label: 'Name',
            value: 'Name',
            hide: false
        },
        {
            label: 'Date',
            value: 'Date',
            hide: false
        },
        {
            label: 'Dispatch Type',
            value: 'Dispatch Type',
            hide: false
        }
    ]

    listOfSelectedValue = [];

    constructor(private viewContainerRef: ViewContainerRef,
        private validationUtilService: ValidationUtilService,
        private apiRequestService: ApiRequestService,
        private route: ActivatedRoute,
        private router: Router,
        private fb: FormBuilder,
        private commonUtilty: CommonUtilty,
        private guidGenerator: GuidGenerator,
        private i18nService: I18nService,
        private multiLingualService: MultiLingualService,
        private translateService: TranslateService,
        private userInfoService: UserInfoService,
        private lookupDataService: LookupDataService,
        private intimationService: IntimationService,
        private interactService: InteractService,
        private appConfig: AppConfig,
        private message: NzMessageService,
        private http: HttpClient,
        private datePipe: DatePipe,
        public adaptersService: AdaptersService,
        public appMetadataHandler: AppMetadataHandler,) { }


    ngOnInit() {
        this.refreshComponents();
        this.getReportLookups();
        this.refreshComponents();

        this.user = this.userInfoService.getUserId();
        this.reportName = "PolicyRpt"

        this.reportList = [{ "lookupKey": "IntRpt", "lookupValue": "Consolidated Claims Report" },
        { "lookupKey": "PolicyRpt", "lookupValue": "Policy Report" }];

        this.reportData = [{ "CLMINTIMATIONNUM": "", "EVENTTYPECD": "", "POLICYNUM": "", "EVENTDT": "" }];

        console.log("dateFrequency", this.dateFrequency)
        console.log("max date set", this.maxDate)
        this.lookup$ = this.commonUtilty.initializeLookupList(this.lookupsToBind) 
    }

    

    refreshReportsComponent = true;
  refreshComponents() {
    this.refreshReportsComponent = false
    setTimeout(() => {
      this.refreshReportsComponent = true
    }, 100);
  }

    getReportLookups() {
        // let lookupArr = ["masterReportNames", "subReportNames"];
        let lookupArr = ["nbuReportNames", "subReportNames"];
        let observables = new Array();
        for (let item of lookupArr) {
            observables.push(this.lookupDataService.getLookup(item));
        }

        forkJoin(observables).subscribe(
            res => {
                let response: any[] = res;
                for (let lookupList of response) {
                    if (lookupList[0].lookupCd == "nbuReportNames") {
                        this.reportNamesList = lookupList;
                        console.log(" reportNamesList " + JSON.stringify(this.reportNamesList));
                    }
                    if (lookupList[0].lookupCd == "subReportNames") {
                        this.subReportNamesList = lookupList;
                        console.log(" SubReportNamesList " + JSON.stringify(this.subReportNamesList));
                    }
                }
                let userRoleDO = this.userInfoService.getUserRoleDO();
                if (userRoleDO.roleId == "BRANCH_USER")
                    this.reportNamesList = this.reportNamesList.filter(e => e.criteriaLookupKey == 'BRANCH');
                else this.reportNamesList = this.reportNamesList.filter(e => e.criteriaLookupKey != 'BRANCH');
                // this.refreshComponents()
            },
            error => console.log('Error: ', error)
        );        
    }

    subReportList = [];
    intialFl = true ;
    getSubReport(reportName){
        this.fromPeriod = null;
        this.toPeriod = null;
        this.fileName = null;
        this.startValue=null;
        this.endValue = null;
        this.showReportTable = false
        this.reportData = [];
        this.tabelHeaders = [];
        
        console.log("selected report category", reportName);

        this.subReportList = this.subReportNamesList.filter( item => {
            return new RegExp("\\b"+ reportName +"\\b").test(item.criteriaLookupKey);
        })
        console.log("sub lookup list", this.subReportList)

        if(this.subReportList.length <= 0){
            this.hideSubReportField = true;
            this.getMetaData(reportName)
        } else{
            this.hideSubReportField = false;
        }

        if(!this.intialFl){
            this.subReportName = null
        }
        this.intialFl = false
    }
    
    fromValue: any;
    getMetaData(reportName, subReportName?) {
        if(reportName == 'HOURLY_PRODUCTIVITY' && (subReportName == 'ASSESSOR' || subReportName == 'APPROVER')){
            this.fromValue = new Date();
            // var startValue = moment(this.fromValue).format('DD-MM-YYYY')
            var startValue = moment(this.fromValue).format('DD-MM-YYYY')
            this.fromPeriod = startValue;
            this.toPeriod = startValue;  
        }
        else{
            this.fromPeriod = null;
            this.toPeriod = null;
        }
        this.fileName = null;
        this.startValue=null;
        this.endValue = null;
        this.showReportTable = false
        this.reportData = [];
        this.tabelHeaders = [];

        if(reportName && subReportName){
            this.culminatedReportName = reportName + "_" + subReportName;
        } else {
            this.culminatedReportName = reportName;
        }

        console.log("culminatedReportName", this.culminatedReportName);
        this.intimationService.getMetaData(this.culminatedReportName).
            subscribe(resp => {
                this.reportMetaData = resp;
                this.sortIOfields(this.reportMetaData);

                this.reportMetaData.forEach( item => {
                    this.tabelHeaders.push(item);
                });
            });

        this.reportNamesList.forEach(tempObj => {
            if (tempObj.lookupKey == reportName)
                this.fileName = tempObj.lookupValue;
        })

    }

    // selectedOutputFields(event, column) {
    //     if (event == true) {
    //         this.reportOutputFields.forEach(headerObj => {
    //             if (headerObj.attributeName == column.attributeName) {
    //                 this.tabelHeaders.push(headerObj);
    //             }
    //         })
    //     }

    //     if (event == false) {
    //         if (this.tabelHeaders) {
    //             this.tabelHeaders.forEach((Obj, i) => {
    //                 if (Obj.attributeName == column.attributeName) {
    //                     this.tabelHeaders.splice(i, 1)
    //                 }
    //             })
    //         }
    //     }

    //     console.log("tabel header");
    //     console.log(this.tabelHeaders);
    // }

    lookup$
    sortIOfields(reportMetaData) {
        this.reportInputfields = [];
        this.tabelHeaders = [];
        this.reportOutputFields = [];
        this.inputFieldsMap = [];
        if (reportMetaData) {
            console.log("length of reportMetadata", reportMetaData.length)
            this.reportInputfields = reportMetaData.filter(obj => obj.attributeTypeCd == "IO" || obj.attributeTypeCd == "I");
            this.reportOutputFields = reportMetaData.filter(obj => obj.attributeTypeCd == "IO" || obj.attributeTypeCd == "O");

            this.inputLookups = this.reportInputfields.filter(obj => { return obj.attributeLookupCd != null });

            if (this.inputLookups) {
                this.inputLookups.forEach(tempElement => {
                    this.lookupsToBind.push(tempElement.attributeLookupCd)
                });

                console.log("lookupsToBind", this.lookupsToBind)
                this.lookup$ = this.commonUtilty.initializeLookupList(this.lookupsToBind) 
            }

        }
        this.reportInputfields.forEach(inputField => {
            var tempObj = {};
            tempObj['reportName'] = inputField.reportName;
            tempObj['attributeName'] = inputField.attributeName;
            tempObj['description'] = inputField.description;
            tempObj['attributeDataTypeCd'] = inputField.attributeDataTypeCd;
            tempObj['attributeLookupCd'] = inputField.attributeLookupCd;
            tempObj['inputValue'] = null;
            this.inputFieldsMap.push(tempObj);
        })

        console.log("maped inputFieldsList", this.inputFieldsMap);
    }

    isInputFieldValid = false
    InputFieldValidation() {
        this.reportData = [];
        let inputPerameters = true
        for (let i = 0; i < this.inputFieldsMap.length; i++) {
            if (this.inputFieldsMap[i].inputValue == null || this.inputFieldsMap[i].inputValue == '' || this.inputFieldsMap[i].inputValue == undefined) {
                if (inputPerameters) {
                    inputPerameters = false;
                }
            }
        }

        this.isInputFieldValid = inputPerameters;
        console.log("field validation", this.isInputFieldValid);
    }

    _transactionInProgress = false
    _exportInProgress=false;
    getReport() {
        // this.isInputFieldValid = this.InputFieldValidation();
        // this.setDateValues();
        this._transactionInProgress = true;
        let userId = null;
        var reportResponse: any;
        let criteriaIOs = [];
        userId = this.userInfoService.getUserId();

        let periodObj = [
            {
                'key': 'fromPeriod',
                // 'value': this.adaptersService.toTimeStamp(this.fromPeriod),
                // 'value': "2024-02-01 03:23:21.163",
                   'value' : moment(this.fromPeriod).format('DD MMM YYYY HH:mm:ss')
            },
            {
                'key': 'toPeriod',
                // 'value': this.adaptersService.toTimeStamp(this.toPeriod),
                // 'value': "2024-02-15 03:23:21.163",
                'value' : moment(this.toPeriod).format('DD MMM YYYY HH:mm:ss')

            },
            {
                'key': 'CURRENCY',
                'value': 'INR'
            }
        ];
        criteriaIOs = periodObj;

        console.log("inputFieldsMap: ", this.inputFieldsMap)
        if (this.inputFieldsMap) {
            this.inputFieldsMap.forEach(obj => {
                let criteriaObj = {
                    'key': '',
                    'value': '',
                };
                criteriaObj['key'] = obj.attributeName;
                criteriaObj['value'] = obj.inputValue;
                // if(criteriaObj['value'] != null)
                criteriaIOs.push(criteriaObj);
            })
        }
        console.log("criteria map", criteriaIOs);

        if (criteriaIOs) {
            let criteriaIO = {}
            if(this.reportName == 'DAILY_MIS_PRODUCTIVITY_NBU'){
                criteriaIOs = [];
                criteriaIO = {criteriaIOs , "reportName": this.culminatedReportName}
            }
            else criteriaIO = { criteriaIOs, "reportName": this.culminatedReportName}

            console.log("criteria IO", criteriaIO)

            this.intimationService.generateReport(criteriaIO).
                subscribe(resp => {
                    if(resp && resp.responseIOs){
                        //this.reportData =resp.responseIOs; 
                        this.reportData = [];
                        this.reportData.push(...resp.responseIOs); 
                        this._transactionInProgress = false;
                        this.showReportTable = true;
                        
                    }else{
                        this._transactionInProgress = false
                        this.message.error(`SERVER ERROR - data not found`, { nzDuration: 4000 })
                    }
                    

                });

            // this.intimationService.generateExcel(criteriaIO).
            //     subscribe(resp => {
            //         console.log("excel response", resp);
            //     });
        }
    }

    previewDataStream: any = null;
    fileFetchEndpoint: string;
    fileUploadEndpoint: string;
    fileFetchEndpointRAW: string;
    base64ToArrayBuffer(base64) {
        var binary_string = window.atob(base64);
        var len = binary_string.length;
        var bytes = new Uint8Array(len);
        for (var i = 0; i < len; i++) {
            bytes[i] = binary_string.charCodeAt(i);
        }
        return bytes.buffer;
    }
    headers: HttpHeaders = new HttpHeaders({
        'Authorization': this.apiRequestService.token,
        'applicationId': environment.applicationId,
        //'hash': '7h1nk[)j',
    });
    generateExcel() {

        let userId = null;
        this._exportInProgress=true;
        var reportResponse: any;
        let criteriaObj = {};
        let criteriaIOs = [];
        userId = this.userInfoService.getUserId();

        let periodObj = [
            {
                'key': 'fromPeriod',
                // 'value': this.fromPeriod,
                'value' : moment(this.fromPeriod).format('DD MMM YYYY HH:mm:ss')
            },
            {
                'key': 'toPeriod',
                // 'value': this.toPeriod,
                'value' : moment(this.toPeriod).format('DD MMM YYYY HH:mm:ss')
            },
            {
                'key': 'CURRENCY',
                'value': 'INR'
            }

        ];
        criteriaIOs = periodObj;

        console.log("inputFieldsMap: ", this.inputFieldsMap)
        if (this.inputFieldsMap) {
            this.inputFieldsMap.forEach(obj => {
                let criteriaObj = {
                    'key': '',
                    'value': '',
                };
                criteriaObj['key'] = obj.attributeName;
                criteriaObj['value'] = obj.inputValue
                // tempObj = criteriaObj;
                criteriaIOs.push(criteriaObj);
            })
        }
        console.log("criteria map", criteriaIOs);

        if (criteriaIOs) {
            let criteriaIO = {}
            if(this.reportName == 'DAILY_MIS_PRODUCTIVITY_NBU'){
                criteriaIOs = [];
                criteriaIO = {criteriaIOs , "reportName": this.culminatedReportName}
            }
            else criteriaIO = { criteriaIOs, "reportName": this.culminatedReportName}


            console.log("criteria IO", criteriaIO)

            // this.fileUploadEndpoint = this.appConfig.baseApiPath + 'cor/download';
            this.fileFetchEndpointRAW = 'generateReport';
            this.fileFetchEndpoint = this.appConfig.baseApiPath + this.fileFetchEndpointRAW;
            this.http.post<Blob>(this.fileFetchEndpoint, criteriaIO, {
                headers: this.headers,
                responseType: 'blob' as 'json'
            }).subscribe(resp => {
                this._exportInProgress=false;
                this.downloadFile(resp);
                // let base64data;
                // let reader = new FileReader();
                // reader.readAsDataURL(resp);
                // let me = this;
                // // this.modalPreview = true;
                // reader.onloadend = function () {
                //     base64data = reader.result;
                //     base64data = base64data.split(',')[1];
                //     /* Decide Charset/Encoding */
                //     let charsetEncoding = 'data:application/xls;base64';
                //     me.previewDataStream = me.base64ToArrayBuffer(base64data); //charsetEncoding + "," + base64data;

                // }
            });
        }
    }

    downloadFile(blob: any): boolean {
        var filename = this.fileName
        if (!filename) filename = 'reportExcel';
        const url = window.URL.createObjectURL(blob);
        const a = document.createElement('a');
        a.setAttribute('style', 'display:none;');
        document.body.appendChild(a);
        a.href = url;
        a.download = filename + '.xls';
        a.click();
        return true;//url;
    }

    getDateModels(selectedDateFrequency){
        this.fromPeriod = null;
        this.toPeriod = null;
        console.log("selected frequency", selectedDateFrequency)
        console.log("globle selected frequency", this.selectedDateFrequency)

        if(selectedDateFrequency === "Daily"){
            this.selectedMonthValue = null;
            this.selectedyearValue = null;
            this.selectFinancialStartYear = null;
            this.selectFinancialEndYear = null;
            this.selectedQtryearValue = null;
            this.selectedQuarter = null;
        }

        if(selectedDateFrequency === "Monthly"){
            this.startValue = null
            this.endValue = null
            this.selectedyearValue = null;
            this.selectFinancialStartYear = null;
            this.selectFinancialEndYear = null;
            this.selectedQtryearValue = null;
            this.selectedQuarter = null;
        }

        if(selectedDateFrequency === "Quarterly"){
            this.startValue = null
            this.endValue = null
            this.selectedMonthValue = null;
            this.selectedyearValue = null;
            this.selectFinancialEndYear = null;
            this.selectFinancialStartYear = null;
        }

        if(selectedDateFrequency === "Yearly"){
            this.startValue = null
            this.endValue = null
            this.selectedMonthValue = null;
            this.selectedQtryearValue = null;
            this.selectedQuarter = null;
            this.selectFinancialStartYear = null;
            this.selectFinancialEndYear = null;
        }

        if(selectedDateFrequency === "Financial Yearly"){
            this.startValue = null
            this.endValue = null
            this.selectedMonthValue = null;
            this.selectedQtryearValue = null;
            this.selectedQuarter = null;
        }
        
        if(selectedDateFrequency === "Since Inception"){
            this.startValue = null
            this.endValue = null
            this.selectedMonthValue = null;
            this.selectedyearValue = null;
            this.selectedQtryearValue = null;
            this.selectFinancialStartYear = null;
            this.selectFinancialEndYear = null;
            this.selectedQuarter = null;

            console.log("into inseption");
            this.fromPeriod = "01-01-2000";
            this.toPeriod = this.datePipe.transform(new Date, 'dd-MM-yyyy HH:mm:ss');
            console.log("inception start date", this.fromPeriod);
            console.log("inception end date", this.toPeriod);
        }
    }

    setDailyDate(){
        console.log("from and to date check", this.startValue, this.endValue);
        var startValue = moment(this.startValue).startOf('day').format('DD MMM YYYY HH:mm:ss');
        
        // console.log(startValue)

        var finalEndDate = moment(this.startValue).endOf('day').format('DD MMM YYYY HH:mm:ss');
        // console.log("final start date", finalStartDate);
        console.log("final end date", finalEndDate);

        this.fromPeriod = startValue
        this.toPeriod = finalEndDate
    }

    startDateOfMonth = "01";
    setMonthlyDate(){
        
        console.log("selected month:---", this.selectedMonthValue)
        // Set to the first day of the selected month and start of time (00:00:00)
        var startOfMonth = moment(this.selectedMonthValue).startOf('month').format('DD MMM YYYY HH:mm:ss');

        // Set to the last day of the selected month and end of time (23:59:59)
        var endOfMonth = moment(this.selectedMonthValue).endOf('month').format('DD MMM YYYY HH:mm:ss');
        console.log("final start of month date: --- ",startOfMonth)
        console.log("final end of month date: --- ",endOfMonth)
        this.fromPeriod = startOfMonth;
        this.toPeriod = endOfMonth;
    }

    setQuarterlyDate(){
        console.log("selected qtr",this.selectedQuarter);
        console.log("selected year", this.selectedQtryearValue);
        var endOfQuarter
        var startOfQuarter
       // Assuming quarter is in the range [1, 4] and year is a valid year
        const quarter = this.selectedQuarter == 'AMJ' ? 2 : this.selectedQuarter == 'JAS' ? 3 : this.selectedQuarter == 'OND' ? 4 : this.selectedQuarter == 'JFM' ? 1 : 1; 
        // Check if the input value is a valid timestamp
        const isTimestamp = moment(this.selectedQtryearValue, moment.ISO_8601, true).isValid();

        // Extract the year if it's a timestamp, otherwise use the input value as is
        const yearValue = isTimestamp ? moment(this.selectedQtryearValue).year() : 2023;

        console.log(yearValue);
         // Calculate the start and end dates for the quarter
        if(quarter && yearValue) startOfQuarter = moment().quarter(quarter).year(yearValue).startOf('quarter').format('DD MMM YYYY HH:mm:ss');
        if(yearValue) endOfQuarter = moment().quarter(quarter).year(yearValue).endOf('quarter').format('DD MMM YYYY HH:mm:ss');

        this.fromPeriod = startOfQuarter
        this.toPeriod = endOfQuarter
        console.log("final qtrly from period:---", this.fromPeriod);
        console.log("final qtrly to period :---", this.toPeriod)
    }

    setYearlyDate(){
        console.log("selected year Value", this.selectedyearValue)
        // Assuming year is a valid year
       // Check if the input value is a valid timestamp
       const isTimestamp = moment(this.selectedyearValue, moment.ISO_8601, true).isValid();

       // Extract the year if it's a timestamp, otherwise use the input value as is
       const yearValue = isTimestamp ? moment(this.selectedyearValue).year() : 2023;
        
       // Calculate the start and end dates for the year
        const startOfYear = moment().year(yearValue).startOf('year').format('DD MMM YYYY HH:mm:ss');
        const endOfYear = moment().year(yearValue).endOf('year').format('DD MMM YYYY HH:mm:ss');
        this.fromPeriod = startOfYear
        this.toPeriod = endOfYear
        console.log("final yearly from period:---", this.fromPeriod);
        console.log("final yearly to period :---", this.toPeriod)
    }

    setFinancialYearDate(){
        console.log("selected year Value", this.selectFinancialStartYear,this.selectFinancialEndYear)
        var startYear
        var endYear
        // Check if the input value is a valid timestamp
        const isFromYearTimestamp = moment(this.selectFinancialStartYear, moment.ISO_8601, true).isValid();
        const isToYearTimestamp = moment(this.selectFinancialEndYear, moment.ISO_8601, true).isValid();
        // Extract the year if it's a timestamp, otherwise use the input value as is
        const fromYear = isFromYearTimestamp ? moment(this.selectFinancialStartYear).year() : 2023;
        const toYear = isToYearTimestamp ? moment(this.selectFinancialEndYear).year() : 2023;

        if(fromYear) startYear = moment().year(fromYear).startOf('year').format('DD MMM YYYY HH:mm:ss');
        if(toYear) endYear = moment().year(toYear).endOf('year').format('DD MMM YYYY HH:mm:ss');
        this.fromPeriod = startYear
        this.toPeriod = endYear
        console.log("final yearly from period:---", this.fromPeriod);
        console.log("final yearly to period:---", this.toPeriod);
    }



    startValue: Date | null = null;
    endValue: Date | null = null;
    selectedMonthValue = null;
    selectedyearValue = null;
    selectedQtryearValue = null;
    selectedQuarter = null;
    selectFinancialStartYear = null;
    selectFinancialEndYear = null;
    // endOpen = false;
  
    disabledStartDate = (startValue: Date): boolean => {
      if (!startValue || !this.endValue) {
        return false;
      }
      return startValue.getTime() > this.endValue.getTime();
    };
  
    disabledEndDate = (endValue: Date): boolean => {
      if (!endValue || !this.startValue) {
        return false;
      }
      return endValue.getTime() <= this.startValue.getTime();
    };
  
    onStartChange(date: Date): void {
      this.startValue = date;
    }
  
    onEndChange(date: Date): void {
      this.endValue = date;

      console.log("selected date or month format:------", this.endValue)
    }

    setFinancialYearStartDate(date: Date): void {
        var startYear
        // Check if the input value is a valid timestamp
        const isFromYearTimestamp = moment(this.selectFinancialStartYear, moment.ISO_8601, true).isValid();
        // Extract the year if it's a timestamp, otherwise use the input value as is
        const fromYear = isFromYearTimestamp ? moment(this.selectFinancialStartYear).year() : 2023;
        
        if(fromYear) startYear = moment().year(fromYear).startOf('year').format('DD MMM YYYY HH:mm:ss');
        this.fromPeriod = startYear
        
        console.log("selected date or month format:------", this.selectFinancialStartYear)
    }

    setFinancialYearEndDate(date: Date): void {
     console.log("selected year Value",this.selectFinancialEndYear)
      var endYear
      // Check if the input value is a valid timestamp
      const isToYearTimestamp = moment(this.selectFinancialEndYear, moment.ISO_8601, true).isValid();
      // Extract the year if it's a timestamp, otherwise use the input value as is
      const toYear = isToYearTimestamp ? moment(this.selectFinancialEndYear).year() : 2023;
      
      if(toYear) endYear = moment().year(toYear).endOf('year').format('DD MMM YYYY HH:mm:ss');
      this.toPeriod = endYear
      console.log("selected date or month format:------", this.selectFinancialEndYear)
    }
  
    // handleStartOpenChange(open: boolean): void {
    //   if (!open) {
    //     this.endOpen = true;
    //   }
    //   console.log('handleStartOpenChange', open, this.endOpen);
    // }
  
    // handleEndOpenChange(open: boolean): void {
    //   console.log(open);
    //   this.endOpen = open;
    // }


    filterTable(value) {
        console.log("selected value", value);
        // if (value && value.length > 0) {
        //     value.forEach(obj => {
        //         if (obj == 'Type') {
        //             this.listOfOption.forEach(reportObj => {
        //                 if (reportObj.label == 'Type')
        //                     reportObj.hide = true;
        //             })
        //         } else if (obj == 'Name') {
        //             this.listOfOption.forEach(reportObj => {
        //                 if (reportObj.label == 'Name')
        //                     reportObj.hide = true;
        //             })
        //         } else if (obj == 'Date') {
        //             this.listOfOption.forEach(reportObj => {
        //                 if (reportObj.label == 'Date')
        //                     reportObj.hide = true;
        //             })
        //         }
        //         else if (obj == 'Dispatch Type') {
        //             this.listOfOption.forEach(reportObj => {
        //                 if (reportObj.label == 'Dispatch Type')
        //                     reportObj.hide = true;
        //             })
        //         }
        //     });
        // }
        // // this.reportList = value;
    }
}